import { render, staticRenderFns } from "./whiteBoard.vue?vue&type=template&id=2c190086&scoped=true&"
import script from "./whiteBoard.vue?vue&type=script&lang=js&"
export * from "./whiteBoard.vue?vue&type=script&lang=js&"
import style0 from "./whiteBoard.vue?vue&type=style&index=0&id=2c190086&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c190086",
  null
  
)

export default component.exports